import { useContext } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { FormContext } from "../../Context/FormContext";
// import { useFormContext } from "../../Context/FormContext";
const ProtectedRoute = ({ children }) => {
  const { signUpDetails } = useContext(FormContext);
  // console.log(signUpDetails);

  const isPrivate = signUpDetails?.companyEmail && signUpDetails?.employeeName;
  // console.log(isPrivate);
  return isPrivate ? <Outlet /> : <Navigate to="/sign-up" replace />;
};

export default ProtectedRoute;
